import { startOfDay, endOfDay, format, subDays, differenceInDays } from 'date-fns';

export const getStartEndLastSevenDays = () => {
  const now = new Date();
  const todayDayStart = startOfDay(now);
  const todayDayEnd = endOfDay(now);
  const days = Array.from({ length: 7 }, (_, i) => i);

  return days
    .map((day) => {
      if (day === 0) {
        return {
          dayStart: format(todayDayStart, "yyyy-MM-dd'T'HH:mm:ss'Z'"),
          dayEnd: now.toISOString(),
        };
      }

      return {
        dayStart: format(subDays(todayDayStart, day), "yyyy-MM-dd'T'HH:mm:ss'Z'"),
        dayEnd: format(subDays(todayDayEnd, day), "yyyy-MM-dd'T'HH:mm:ss'Z'"),
      };
    })
    .sort((a, b) => differenceInDays(new Date(a.dayStart), new Date(b.dayStart)));
};
